export default "./static/editor/version-img.png?2"